/**
 * Helpers for the student address verification chip.
 *
 * Addresses here are always in the student grid's shape:
 * { address1, address2, city, stateId, zip }
 */

function comparable (value) {
  return String(value == null ? '' : value).trim().toLowerCase().replace(/\s+/g, ' ')
}

/**
 * Fingerprint of an address. Verification results are cached by it, so a
 * result follows the address rather than the row: edit the address and the
 * row reads as unchecked, change it back and the earlier result applies again.
 *
 * Normalized the same way the API's addressHash is, so spacing and case
 * never read as a different address.
 */
export function addressKey (address = {}) {
  return [
    comparable(address.address1),
    comparable(address.address2),
    comparable(address.city),
    String(Number(address.stateId) || ''),
    comparable(address.zip),
  ].join('|')
}

/**
 * Enough of an address for Google to have something to match against.
 */
export function isCheckable (address = {}) {
  return !!(comparable(address.address1) && comparable(address.city) && Number(address.stateId))
}

export function pickAddress (student = {}) {
  return {
    address1: student.address1,
    address2: student.address2,
    city: student.city,
    stateId: student.stateId,
    zip: student.zip,
  }
}

/**
 * A roster draft student's address. Drafts hold the state as its two letter
 * code; `states` is the shared lk_state lookup.
 */
export function draftAddress (draft = {}, states = []) {
  const code = String(draft.STATE || '').trim().toUpperCase()
  const state = states.find(s => String(s.STATE).trim().toUpperCase() === code)
  return {
    address1: draft.ADDRESS1,
    address2: draft.ADDRESS2,
    city: draft.CITY,
    stateId: state ? state.LK_STATE_ID : null,
    zip: draft.ZIP,
  }
}
